export const IconCvdbCvFolder20: {
  name: 'icon_cvdb_cv_folder_20-f44ce788c45b'
} = {
  name: 'icon_cvdb_cv_folder_20-f44ce788c45b'
}
